import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSpotX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M16.11 10.705c-.148.894-.624 1.43-1.427 1.604.518.283.866.64 1.045 1.073.178.433.147.974-.093 1.624-.124.331-.281.61-.471.836-.19.226-.4.399-.63.517-.23.118-.497.197-.801.236a4.307 4.307 0 0 1-.93.016 8.755 8.755 0 0 1-1.062-.169l-.491 1.832-1.094-.293.483-1.803a40.125 40.125 0 0 1-.864-.24l-.486 1.811-1.093-.293.49-1.832a31.237 31.237 0 0 1-.382-.107l-.39-.108-1.42-.38.572-1.256.789.21c.236.064.406-.021.51-.255l.774-2.889.113.03a.74.74 0 0 0-.111-.037l.552-2.062c.026-.343-.141-.562-.5-.658l-.79-.212.316-1.178 1.504.41c.303.082.534.141.691.178L11.4 5.5l1.094.292-.475 1.775c.39.095.68.167.87.218l.472-1.76 1.094.293-.486 1.81c.366.134.683.277.952.429.269.151.507.33.716.538.208.207.353.446.436.717.082.272.095.569.038.893Zm-2.576 3.507c.046-.173.052-.335.017-.489a1.114 1.114 0 0 0-.175-.4 1.393 1.393 0 0 0-.35-.33 3.541 3.541 0 0 0-.429-.257 4.284 4.284 0 0 0-.508-.205 7.824 7.824 0 0 0-.945-.269 21.873 21.873 0 0 1-.339-.083l-.65 2.429c.037.01.124.034.261.074l.34.095a9.253 9.253 0 0 0 .803.172c.119.02.26.035.42.048.162.012.303.014.422.005.12-.01.245-.03.378-.06a1.02 1.02 0 0 0 .338-.141.995.995 0 0 0 .417-.59Zm.435-4a1.036 1.036 0 0 0-.135-.36c-.064-.102-.16-.2-.287-.293a2.505 2.505 0 0 0-.36-.223 3.998 3.998 0 0 0-.42-.174 4.223 4.223 0 0 0-.408-.129 53.276 53.276 0 0 1-.667-.167l-.59 2.206.243.07a7.791 7.791 0 0 0 .69.169c.158.034.291.056.4.065.11.008.24.015.388.019.148.004.275-.01.38-.04a2.03 2.03 0 0 0 .315-.125.716.716 0 0 0 .266-.225c.072-.099.126-.215.162-.35a.986.986 0 0 0 .024-.443Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12Z"
    />
  </svg>
);
export default SvgTwoColorSpotX;
